import { fansupportPublic } from "./index";

export const getTournament = async ({sportId, countryId}) => {
    return fansupportPublic.get('/sport/filter',{ params: { 
        sportId,
        countryId,
    } } )
} 